import { forwardRef, PropsWithChildren } from 'react';
import classNames from 'classnames';

import * as S from './body.styles';

export const ModalBodyTestId = {
  body: 'modal-body',
};

export const ModalBody = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ className?: string }>
>(({ children }, ref) => {
  return (
    <S.ModalBodyContainer
      data-testid={ModalBodyTestId.body}
      className={classNames('modal-body', classNames)}
      ref={ref}
    >
      {children}
    </S.ModalBodyContainer>
  );
});
